import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=0f224a09&scoped=true"
import script from "./Basic.vue?vue&type=script&lang=js"
export * from "./Basic.vue?vue&type=script&lang=js"
import style0 from "./Basic.scss?vue&type=style&index=0&id=0f224a09&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f224a09",
  null
  
)

export default component.exports